import React from "react";
import "../App.scss";
import AclApi from "../api/AclApi";
import LeftMenu from "./LeftMenu";
import ReactLoading from 'react-loading';
import If from "./If";

class AuthorizedPage extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.hasPageOpenPrivilege = this.hasPageOpenPrivilege.bind(this);
    this.state = { hasPrivilege: false };
    this.hasPageOpenPrivilege();
  }

  async hasPageOpenPrivilege() {
    let response = await AclApi.hasPageOpenRole(this.props.role);

    if (response.success) {
      this.setState({ hasPrivilege: true });
    } else {
      this.setState({ hasPrivilege: false });
    }
  }

  componentDidMount() {
    setTimeout(() => {
      const hasPrivilege = this.state.hasPrivilege;
      if (!hasPrivilege) {
        window.location.assign("/portal-giris");
      }
    }, 2650);
  }

  render() {
    const hasPrivilege = this.state.hasPrivilege;
    if (!hasPrivilege) {
      return (
        <div className="zero-div centered-60-percent">
          <p></p>
        </div>
      );
    }
    return (
      <div className="zero-div">
        <div style={{marginLeft:"35px", paddingTop:"25px", paddingBottom:"15px"}}>
            <img width="180px" height="60px" src="https://ozisiksut.com.tr/wp-content/uploads/2021/10/weblogo1.png"></img>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-2">
            <LeftMenu></LeftMenu>
          </div>
          <div className="col-10">
            <If value = {this.props.isLoading || false}>
              <div style={{position:"fixed", display:"block", left:"50%", top:"25px"}}>
                <ReactLoading type="bars" color="red" height={70} width={70} />
              </div>
            </If>
            {this.props.children}
            </div>
        </div>
      </div>
    );
  }
}

export default AuthorizedPage;
